import StatusChange from './status_change'

export default StatusChange
